import React from 'react';
import { TERMS_AND_CONDITIONS_LINK } from '../../constants';
/**
 * Custom strings hotfix for LendLease projects
 * 6023f4a08f352a0004d476b4
 * 602528ffba2ffe00045aa2f3
 */
function _isLendleaseProject(slugId) {
  const arrayOfIds = [
    '6023f4a08f352a0004d476b4',
    '602528ffba2ffe00045aa2f3',
    '5f1aa18b767884000418e15d',
    '6022903a696d0f00046eb399',
    '6008352dfa358500040740cf',
  ];
  return arrayOfIds.includes(slugId);
}

function LendLeaseCheckboxLabel() {
  return (
    <React.Fragment>
      I agree to{' '}
      <a className='c-link' href={TERMS_AND_CONDITIONS_LINK} target='_blank' rel='noopener noreferrer'>
        Give My View&apos;s
      </a>{' '}
      & Lendlease&apos;s{' '}
      <a className='c-link' href='https://www.highroadwest.london/privacy/' target='_blank' rel='noopener noreferrer'>
        Privacy Policy{' '}
      </a>{' '}
      and{' '}
      <a
        className='c-link'
        href='https://www.highroadwest.london/terms-of-use/'
        target='_blank'
        rel='noopener noreferrer'
      >
        {' '}
        Terms and Conditions{' '}
      </a>
    </React.Fragment>
  );
}

const LendLeaseCheckboxLink = 'How we will use your data?';

const LendLeaseAcceptCheckBoxDescription =
  'Lendlease companies and our agents will only contact you regarding your feedback and in accordance with our privacy policy and terms and conditions. We will not share your data with anyone else.';

export { _isLendleaseProject, LendLeaseCheckboxLabel, LendLeaseCheckboxLink, LendLeaseAcceptCheckBoxDescription };
